import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {isOptionalString, parseEachOrNull} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import {isPlainObject} from '@Utils/object.util';
import type {OptionGridLimitNotice, OptionGridOption, OptionGridProps} from './option-grid.types';
import {OptionGrid} from './option-grid';

const parseOption = (value: Record<string, unknown>): OptionGridOption | null => {
  if (typeof value.id !== 'string' || typeof value.label !== 'string' || !isOptionalString(value.iconUrl)) {
    return null;
  }

  return {id: value.id, label: value.label, iconUrl: value.iconUrl, actionData: isPlainObject(value.actionData) ? value.actionData : undefined};
};

const parseLimitNotice = (value: unknown): OptionGridLimitNotice | undefined | null => {
  if (value === undefined) {
    return undefined;
  }

  if (!isPlainObject(value) || typeof value.text !== 'string' || typeof value.showUpgrade !== 'boolean') {
    return null;
  }

  return {text: value.text, showUpgrade: value.showUpgrade};
};

const parseOptionGridProps = (props: Record<string, unknown>): OptionGridProps | null => {
  if (typeof props.actionType !== 'string' || !Array.isArray(props.options)) {
    return null;
  }

  const options = parseEachOrNull(props.options, parseOption);
  const limitNotice = parseLimitNotice(props.limitNotice);
  if (options === null || limitNotice === null || (options.length === 0 && limitNotice === undefined)) {
    return null;
  }

  return {options, actionType: props.actionType, limitNotice};
};

export const optionGridRegistration = defineStreamComponentRegistration(StreamComponentType.OPTION_GRID, OptionGrid, parseOptionGridProps);
